__turbopack_context__.v({
  "cartCheckoutTotals": "cartCheckoutTotals-module-scss-module__O0CIRq__cartCheckoutTotals",
  "couponRow": "cartCheckoutTotals-module-scss-module__O0CIRq__couponRow",
  "editCart": "cartCheckoutTotals-module-scss-module__O0CIRq__editCart",
  "estimateButton": "cartCheckoutTotals-module-scss-module__O0CIRq__estimateButton",
  "loader": "cartCheckoutTotals-module-scss-module__O0CIRq__loader",
  "removeCouponButton": "cartCheckoutTotals-module-scss-module__O0CIRq__removeCouponButton",
  "shippingUnavailable": "cartCheckoutTotals-module-scss-module__O0CIRq__shippingUnavailable",
  "showEditCart": "cartCheckoutTotals-module-scss-module__O0CIRq__showEditCart",
  "tempAuth": "cartCheckoutTotals-module-scss-module__O0CIRq__tempAuth",
  "total": "cartCheckoutTotals-module-scss-module__O0CIRq__total",
});
